export const taxesEn = {
  taxes: `Taxes`,
  taxes_management: `Taxes Management`,
  add_tax: `Add Tax`,
  edit: `Edit`,
  delete: `Delete`,
  active: `Active`,
  inactive: `Inactive`,
  yes: `Yes`,
  no: `No`,
  code: `Code`,
  description: `Description`,
  tax_type: `Tax Type`,
  rate: `Rate`,
  withholding: `Withholding`,
  actions: `Actions`,
  exempt: `Exempt`,
  tax: `Tax`,
  delete_tax_dialog: `Are you sure you want to delete this tax?`,
  VAT_label: `VAT - Value Added Tax`,
  IGIC_label: `IGIC - Canary Island Tax`,
  IRPF_label: `IRPF - Personal Income Tax`,
  WHT_label: `WHT - Withholding Tax`,
  select_compliance_standard: `Please select compliance standard`,
  VeriFactu_label: `VeriFactu`,
  SII_label: `SII`,
  SDI_label: `SDI`,
  successfully_deleted: `Tax deleted successfully`,
  delete_failed: `Failed to delete tax`,
  something_went_wrong: `Something went wrong`,
  is_withholding_tax: `Is Withholding Tax`,
  compliance_standard: `Compliance Standard`,
  edit_tax: `Edit Tax`,
  exempt_code: `Exempt Code`,
  tax_type_required: `Tax type is required`,
  rate_required: `Rate is required`,
  rate_min: `Rate must be greater than or equal to 0`,
  exempt_code_required: `Exempt code is required for withholding tax`,
  compliance_standard_required: `Compliance standard is required`,
  please_select: `Please select`,
  select_tax_type: `Please select tax type`,
  code_disabled_withholding: `Code is disabled when Withholding is checked`,
  organization_not_found: `Organization not found for the current user`,
  invalid_tax_rate_range: `Tax rate must be between 0 and 100`,
  exempt_code_required_for_zero_rate: `Exempt code is required when tax rate is 0%`,
  tax_code_required: `Tax code is required`,
  duplicate_tax_rate_for_exemptcode: `An active tax already exists with TaxType '{{0}}', Rate '{{2}}%', and ExemptCode '{{1}}'`,
  duplicate_tax_rate_for_code: `An active tax already exists with TaxType '{{0}}', Rate '{{2}}%', and Code '{{1}}'`,
  tax_not_found: `Tax not found`,
  tax_updated_success: `Tax updated successfully`,
  tax_created_success: `Tax created successfully`,
  error_fetching_tax_data: `Error fetching tax data`,
  code_is_required: `Code is required`,
};
